import * as React from "react"
import {Skeleton} from "@mui/material";
import {AmchartSeeker} from "@ui-seeker/core";
import {capitalize} from "@ui-seeker/utils";

import {useUserActivityEvolution} from "../../@hooks";
import UserActivitiesEvolutionActions from "./Actions";
import {DATE_FORMAT, DATE_FORMAT_RECEIVED, DATE_METRICS, TIME_UNIT} from "@constants";
import {metric} from "@signals";


export default function UserActivitiesEvolution() {
	const { evoData, isLoadingEvo, kpi, handleChangeKpi } = useUserActivityEvolution()

	if (isLoadingEvo) return <Skeleton variant="rectangular" height={500} />
	if (!evoData.length) return <></>

	return <AmchartSeeker
		data={evoData}
		title={`Evolution by ${capitalize(kpi)}`}
		pdfProps={{
                titlePDF:`Evolution by ${capitalize(kpi)}`
            }}
		series={[{
			name: capitalize(kpi),
			yField: kpi,
			xField: "date",
			type: "column"
		}]}
		chartProps={{
			numberFormat: "#,###",
			dateFormatReceived: DATE_FORMAT_RECEIVED[metric.value],
			xAxis: {
				categoryField: 'date',
				isDateAxis: metric.value !== DATE_METRICS.QUARTERLY,
				dateFormat: DATE_FORMAT[metric.value],
                baseInterval: {
                    timeUnit: TIME_UNIT[metric.value],
                    count: 1
                }
			}
		}}
		cardProps={{ actions: <UserActivitiesEvolutionActions value={kpi} onChange={handleChangeKpi} /> }}
	/>
}